import { openDialog } from '@patrianna/dialog-manager'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { ChevronRight } from '@patrianna-icons/material-icons'
import cx from 'classnames'
import { useRouter } from 'next/navigation'

import ROUTES from 'config/routes.json'
import content from 'prismic-translates/page-profile.json'
import { useAppSelector } from 'store/hooks'
import { getIsSoftKYCAvailableSelector } from 'store/modules/user/selectors'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

function Verifications() {
  const isSoftKYCAvailable = useAppSelector(getIsSoftKYCAvailableSelector)
  const router = useRouter()

  const openSubmitDocumentDialog = () => router.push(ROUTES.VERIFICATIONS)

  const onClickHandler = () => {
    if (isSoftKYCAvailable) {
      return openSubmitDocumentDialog()
    }

    openDialog({ dialogName: 'SOFT_KYC_DIALOG', dialogProps: { callBack: openSubmitDocumentDialog } })
  }

  return (
    <a data-test='my-account-verify' className={classes.verifyRowContainer} onClick={onClickHandler}>
      <button type='button' className={cx('link', classes.verifyButton)}>
        {t('verify_account')}
      </button>
      <ChevronRight className={classes.iconArrow} />
    </a>
  )
}

export default Verifications
